import { inject, Injectable } from '@angular/core';
import { filter, first, map, share, Subject, switchMap, timer } from 'rxjs';
import { ModalLayoutComponent } from './modal-layout.component';
import { ModalComponent } from './modal.component';
import { ModalContent, ModalOptions } from './model';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  private _layout?: ModalLayoutComponent
  private _modals: ModalComponent[] = []
  private _activeModalSubject = new Subject<ModalComponent>()

  get layout() {
    if (this._layout) {
      return this._layout
    }
    throw new Error('ModalLayoutComponent not exists')
  }

  get activeModal() {
    return this._modals.length ? this._modals[this._modals.length - 1] : undefined
  }

  registerLayout(comp: ModalLayoutComponent) {
    if (this._layout) {
      throw new Error('ModalLayoutComponent already exists')
    }
    this._layout = comp
  }

  registerModal(comp: ModalComponent) {
    this._modals.push(comp)
    this._activeModalSubject.next(comp)
    this.fixOverflow()
  }

  create(content: ModalContent, options?: Partial<ModalOptions>) {
    // Откладываем на следующий тик, чтобы layout и модалка успели зарегистрироваться
    const obs = timer(0).pipe(
      map(() => this.layout.create(content, options)),
      switchMap(id => this._activeModalSubject.pipe(
        filter(comp => comp.id() == id),
        first()
      )),
      share()
    )
    obs.subscribe()
    return obs
  }

  destroy(comp: ModalComponent) {
    this.layout.destroy(comp.id())
    const i = this._modals.findIndex(m => m.id() == comp.id())
    if (i >= 0) {
      this._modals.splice(i, 1)
    }
    this.fixOverflow()
  }

  private fixOverflow() {
    if (this._modals.length) {
      document.documentElement.style.overflow = 'hidden'
    } else {
      document.documentElement.style.overflow = 'auto'
    }
  }

}



@Injectable({
  providedIn: 'root'
})
export class ActiveModalService {

  private modal = inject(ModalService)

  get component() {
    return this.modal.activeModal
  }

  destroy() {
    if (this.component) {
      this.modal.destroy(this.component)
    }
  }

}
